import { render, staticRenderFns } from "./appConfig.vue?vue&type=template&id=00b6e61c&scoped=true"
import script from "./appConfig.vue?vue&type=script&lang=js"
export * from "./appConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b6e61c",
  null
  
)

export default component.exports